(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("core-tracking-objects", [], factory);
	else if(typeof exports === 'object')
		exports["core-tracking-objects"] = factory();
	else
		root["core-tracking-objects"] = factory();
})(self, function() {
return 